import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import { checkPermission } from '../utils/permission';

interface AdminRouteProps {
    children: JSX.Element;
}

const AdminRoute = ({ children }: AdminRouteProps) => (
    <PrivateRoute>
        {checkPermission(2) ? children : <Navigate to="/dashboard" replace />}
    </PrivateRoute>
);

export default AdminRoute;
